//#region src/menu_cover_promotion_image_size.ts
let MenuCoverPromotionImageSize = /* @__PURE__ */ function(MenuCoverPromotionImageSize) {
	MenuCoverPromotionImageSize["GcnHalfWidth"] = "gcn-half-width";
	MenuCoverPromotionImageSize["GcnFullWidth"] = "gcn-full-width";
	MenuCoverPromotionImageSize["VitrineSmHalfWidth"] = "vitrine-sm-half-width";
	MenuCoverPromotionImageSize["VitrineSmFullWidth"] = "vitrine-sm-full-width";
	MenuCoverPromotionImageSize["VitrineMdHalfWidth"] = "vitrine-md-half-width";
	MenuCoverPromotionImageSize["VitrineMdFullWidth"] = "vitrine-md-full-width";
	MenuCoverPromotionImageSize["VitrineRgHalfWidth"] = "vitrine-rg-half-width";
	MenuCoverPromotionImageSize["VitrineRgFullWidth"] = "vitrine-rg-full-width";
	return MenuCoverPromotionImageSize;
}({});
//#endregion
export { MenuCoverPromotionImageSize };

//# sourceMappingURL=menu_cover_promotion_image_size.js.map